import identity from "./identity.js";
function throwIf(predicate, err = identity) {
    return (input) => {
        if (predicate(input))
            throw err(input);
        return input;
    };
}
export default throwIf;
//# sourceMappingURL=throwIf.js.map